import { render, staticRenderFns } from "./charts_rank.vue?vue&type=template&id=6dd9a664&scoped=true"
import script from "./charts_rank.vue?vue&type=script&lang=js"
export * from "./charts_rank.vue?vue&type=script&lang=js"
import style0 from "./charts_rank.vue?vue&type=style&index=0&id=6dd9a664&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9a664",
  null
  
)

export default component.exports